module.exports = __webpack_public_path__ + "static/media/Error.929badc2.svg";